import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import bind from 'bind-decorator';
import {FlowWireMenuContext} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {MenuItem} from '@mintdata-wsp/wsp/ui/components/menus/MenuItem';
import {
    DesignerContextMenu,
    DesignerMenuInfo
} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/menus/DesignerContextMenu';

const styles = require('./FlowWireContextMenu.less');
const cx = classnames.bind(styles);

export enum WireMenuId
{
    DeleteWire = 'DeleteWire',
}

export class WireMenuConfig
{
    private _menuItems:MenuItem[];

    public static generateMenuItems(ctx:FlowWireMenuContext):MenuItem[]
    {
        const handleClickFn = WireMenuConfig._handleMenuClick;

        return [
            MenuItem.simple(WireMenuId.DeleteWire, `Delete`, handleClickFn)
        ];
    }

    public getMenuItems():MenuItem[]
    {
        return this._menuItems;
    }

    private static _handleMenuClick(menuItem:MenuItem):void
    {
        switch( menuItem.id )
        {
            case WireMenuId.DeleteWire:
            {
                const controller = controllers.ui.flowCanvas;
                const selectedWire = controllers.ui.flowSelection.getSelectedWire();

                if( selectedWire )
                {
                    controllers.ui.flowSelection.clearSelectedWire();
                    controller.removePermanentWire(selectedWire);
                    controller.closeWireContextMenu();
                }

                break;
            }
        }
    }
}

@observer
export class FlowWireContextMenu extends React.Component<any, any>
{
    @bind
    private _getMenuInfo():DesignerMenuInfo
    {
        const controller = controllers.ui.flowCanvas;
        const context = controller.getFlowWireMenuContext();

        if( !context )
            return DesignerMenuInfo.None();
        else
        {
            const e = context.mouseDownEvent;
            const menuItems = WireMenuConfig.generateMenuItems(context);

            return new DesignerMenuInfo(true, menuItems, e.clientX, e.clientY);
        }
    }

    render()
    {
        return <DesignerContextMenu getPopupMenuInfo={this._getMenuInfo}/>;
    }
}
